import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeviceService } from '../device.service';
@Component({
  selector: 'app-add-device',
  templateUrl: './add-device.component.html',
  styleUrls: ['./add-device.component.css']
})
export class AddDeviceComponent implements OnInit {
  imei: string;
  model: string;
  device: any;
  constructor(private http: HttpClient, public snackBar: MatSnackBar, private router: Router, private deviceService: DeviceService) {
  }

  ngOnInit() {
  }

  submit() {
    this.deviceService.AddDevice2({imei: this.imei, model: this.model}).subscribe(
      (data) => {
        console.log(data);
        this.snackBar.open('Success', '', {
          duration: 1250,
          verticalPosition: 'top',
          horizontalPosition: 'end'
        });
        this.router.navigate(['device/search', {imei: this.imei}]);
      },
      (error) => {
        console.log(error);
        this.snackBar.open('Something went wrong', '', {
          duration: 1250,
          verticalPosition: 'top',
          horizontalPosition: 'end'
        });
      }
    );
  }
}




// WEBPACK FOOTER //
// ./src/app/add-device/add-device.component.ts